<template>
  <div class=" padding-left-30 padding-right-30 padding-bottom-30" v-loading="fullscreenLoading">
    <div class="vctb-list">
      <div class="vctb-item" :class="{'vctb-item-active':vctbIndex==0}" @click="tabChange(0)">
        全部 ({{ tender_count['all'] || 0 }})
      </div>
      <div class="vctb-item" :class="{'vctb-item-active':vctbIndex==1}" @click="tabChange(1)">
        招标 ({{ tender_count['a1'] || 0 }})
      </div>
      <div class="vctb-item" :class="{'vctb-item-active':vctbIndex==2}" @click="tabChange(2)">
        中标 ({{ tender_count['a2'] || 0 }})
      </div>
    </div>
    <div class="padding-left-10 padding-right-10 ">
      <div class="box5 box2_cc">
        <div class="box5_text2 text-bold">发布日期</div>
        <div class="box5_text2 text-bold">发布渠道</div>
        <div class="box5_text2 text-bold">公告标题</div>
        <div class="box5_text2 text-bold">采购单位</div>
        <div class="box5_text2 text-bold width-80 justify-center" style="flex:none;">操作</div>
      </div>
      <div v-for="(item, index) in list" :key="index" class="box5">
        <div class="box5_text2"> {{ item.pubtime ? dayjs(Number(item.pubtime) * 1000).format('YYYY-MM-DD') : "--" }}
        </div>
        <div class="box5_text2">{{ item.comeFromArr || "其它网站（细类不明）" }}</div>
        <div class="box5_text2">{{ item.title || '--' }}</div>
        <div class="box5_text2">{{ item.owner || '--' }}</div>
        <div class="box5_text2  justify-center  width-80  " style="flex:none;">
          <span class="cpoint" style="color: #0070c0;" @click="clickShow(item)">详情</span>
        </div>
      </div>
      <div class="padding-bottom-40" v-if="!list.length">
        <nomore></nomore>
      </div>

      <div class="text-right " style="padding: 10px 0">
        <el-pagination background :page-size="pagesize" :page-sizes="pageSizes" :hide-on-single-page="false"
            layout="prev, pager, next,sizes" @size-change="handleSizeChange"
            @current-change="handleCurrentChange($event)" :current-page="currentPage" :total="totalnum">
        </el-pagination>
      </div>
    </div>

    <el-dialog :title="showData.type" :visible.sync="showDetail">
      <div style="height:70vh;overflow-y: scroll;">
        <table class="pure-table pure-table-bordered">
          <tbody>
          <tr>
            <td style="width:30%;background: #F7F7F7;">招标公告标题</td>
            <td>{{ showData.title || "--" }}</td>
          </tr>
          <tr>
            <td style=" background: #F7F7F7;">发布渠道</td>
            <td>{{ showData.comeFromArr || "--" }}</td>
          </tr>
          <tr>
            <td style=" background: #F7F7F7;">项目名称</td>
            <td>{{ showData.projectName || '--' }}</td>
          </tr>
          <tr>
            <td style=" background: #F7F7F7;">公告类型(细类)</td>
            <td>{{ showData.projectName || '--' }}</td>
          </tr>
          <tr>
            <td style=" background: #F7F7F7;">项目更新时间</td>
            <td>
              {{ showData.update_time ? dayjs(Number(showData.update_time) * 1000).format('YYYY-MM-DD') : "--" }}
            </td>
          </tr>
          <tr>
            <td style=" background: #F7F7F7;">项目编号</td>
            <td>{{ showData.projectNum || '--' }}</td>
          </tr>
          <tr>
            <td style=" background: #F7F7F7;">项目发布时间</td>
            <td>{{ showData.blockTime || '--' }}</td>
          </tr>
          <tr>
            <td style=" background: #F7F7F7;">项目截止时间</td>
            <td>{{ showData.blockTime || '--' }}</td>
          </tr>
          <tr>
            <td style=" background: #F7F7F7;">采购单位</td>
            <td>{{ showData.owner || '--' }}</td>
          </tr>
          <tr>
            <td style=" background: #F7F7F7;">采购单位地址</td>
            <td>{{ showData.ownerAddress || '--' }}</td>
          </tr>
          <tr>
            <td style=" background: #F7F7F7;">采购联系人</td>
            <td>{{ showData.ownerPerson || '--' }}</td>
          </tr>
          <tr>
            <td style=" background: #F7F7F7;">采购联系方式</td>
            <td>{{ showData.ownerPhone || '--' }}</td>
          </tr>
          <tr>
            <td style=" background: #F7F7F7;">项目所属地</td>
            <td>{{ showData.region || '--' }}</td>
          </tr>
          <tr>
            <td style=" background: #F7F7F7;">代理机构</td>
            <td>{{ showData.agency || '--' }}</td>
          </tr>
          <tr>
            <td style=" background: #F7F7F7;">代理机构地址</td>
            <td>{{ showData.agencyAddress || '--' }}</td>
          </tr>
          <tr>
            <td style=" background: #F7F7F7;">代理机构联系方式</td>
            <td>{{ showData.agencyPersor || '--' }}</td>
          </tr>
          <tr>
            <td style=" background: #F7F7F7;">项目预算金额</td>
            <td>{{ showData.budget || '--' }}</td>
          </tr>
          <!-- <tr>
          <td style=" background: #F7F7F7;">PPP项目标识</td>
          <td>{{showData.bidPrice|| '--'}}</td>
        </tr> -->
          <!-- <tr>
          <td style=" background: #F7F7F7;">招标公告内容</td>
          <td>{{showData.bidUnit|| '--'}}</td>
        </tr> -->

          <template v-if="showData.type=='中标公告'">
            <tr>
              <td style=" background: #F7F7F7;">中标成交金额</td>
              <td>{{ showData.bidPrice || '--' }}</td>
            </tr>
            <tr>
              <td style=" background: #F7F7F7;">中标单位</td>
              <td>{{ showData.bidUnit || '--' }}</td>
            </tr>
            <tr>
              <td style=" background: #F7F7F7;">中标单位地址</td>
              <td>{{ showData.bidUnit || '--' }}</td>
            </tr>
          </template>

          </tbody>
        </table>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import dayjs from "dayjs"

export default {
  props: {
    id: {
      type: [String, Number],
      default: ""
    },
    detail: {
      type: Object,
      default: ""
    }
  },
  data() {
    return {
      list: [],
      totalnum: 0,
      currentPage: 1,
      pagesize: 10,
      type: 0,
      vctbIndex: 0,
      showDetail: false,
      showData: {},

      check_list: [],
      checkShow: false,
      checkData: {},
      totalnum1: 0,
      type: 0,
      tender_count: {},
      pageSizes: [10, 20, 30, 40, 50],
      fullscreenLoading: false
    }
  },
  methods: {
    dayjs,
    tabChange(e) {
      this.vctbIndex = e
      this.currentPage = 1
      this.getlist()
    },
    clickShow(e) {
      this.showData = e
      this.showDetail = true;
    },
    getlist() {
      this.fullscreenLoading = true
      var api = this.$api.api.interfacenew.tender_list;
      this.$https.post({
            api: api,
            type: "formData",
          }, {
            start: this.currentPage,
            page_size: this.pagesize,
            id: this.id,
            type: this.vctbIndex, //类型 招投标类型: 0-全部，1-招标，2-中标
          },
          (response) => {
            this.list = response.data;
            this.totalnum = response.count;
            this.fullscreenLoading = false
          },
          (error) => {
            // console.log(error);
          }
      );
    },
    getTenderCount() {
      var api = this.$api.api.interfacenew.tender_count;
      this.$https.post({
            api: api,
            type: "formData",
          }, {
            id: this.id,
          },
          (response) => {
            this.tender_count = response.data
            let num = 0
            for (let i in response.data) {
              num += response.data[i]
            }

          },
          (error) => {
            // console.log(error);
          }
      );
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getlist();
    },
    handleSizeChange(size) {
      this.pagesize = size;
      this.currentPage = 1;
      this.getlist();
    },
    toout(href) {
      // console.log(href)
      if (!href) {
        return false;
      }
      window.open(href)
    },
  },
  created() {
    this.getTenderCount()
    this.getlist();
  }
}
</script>

<style lang="scss" scoped>
@import '../detailcss.scss';
</style>



// WEBPACK FOOTER //
// tender-page.vue?1d42ad1c